import styles from './results.module.css';
import ResultBox from './resultBox/resultBox';

const Results = ({ resultObj }) => {
    const result = resultObj;

    let resultsList = []

    result['claims'].forEach(result => {
        resultsList.push(<ResultBox result = {result}/>);
    });

    return(
        <div className = {styles.body}>
            {resultsList}
        </div>
    )
}

export default Results;